import type { ImgWebConfig } from '../types';

export const imgWebConfig: ImgWebConfig = {
  hostUrlDev: 'https://image-assets-server-dot-cms-headless-gae.ew.r.appspot.com/',
  hostUrlProd: '/'
};

export const imgWebConfigTg: ImgWebConfig = {
  hostUrlDev: 'https://image-assets-server-dot-cms-headless-gae.ew.r.appspot.com/',
  hostUrlProd: 'https://januszcasinotg.com/'
};
